export interface AppConfig {
  apiBaseUrl: string;
  slug: string;
  groupFilter: string | null;
  refreshIntervalSeconds: number;
  isMockDefault: boolean;
}

export const config: AppConfig = {
  // If VITE_KUMA_API_URL is specified (e.g. for cross-domain direct access), use that,
  // otherwise relative to current origin / proxy path
  apiBaseUrl: import.meta.env.VITE_KUMA_API_URL?.trim() || "",
  slug: import.meta.env.VITE_KUMA_SLUG?.trim() || "legalease",
  // By default, show all groups in the dedicated "legalease" status page,
  // or filter if explicitly provided via VITE_GROUP_FILTER.
  groupFilter: import.meta.env.VITE_GROUP_FILTER?.trim() || null,
  refreshIntervalSeconds: Number(import.meta.env.VITE_REFRESH_INTERVAL || 60),
  isMockDefault: import.meta.env.VITE_MOCK === "1" || import.meta.env.VITE_MOCK === "true",
};
